// extracted by mini-css-extract-plugin
module.exports = {"emptyStateMessage":"NoSessionMessage_emptyStateMessage__35kIc","activitiesLink":"NoSessionMessage_activitiesLink__18Zwt"};